import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down",
  "use": "icon-down-usage",
  "viewBox": "0 0 1033 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1033 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-down\"><defs><style type=\"text/css\"></style></defs><path d=\"M1022.976 308.224 594.944 736.256c-43.008 43.008-113.664 43.008-156.672 0L9.216 307.2c-12.288-11.264-12.288-30.72 0-43.008 11.264-12.288 30.72-12.288 43.008 0l430.08 429.056c9.216 9.216 21.504 14.336 34.816 14.336 13.312 0 25.6-5.12 34.816-14.336l428.032-428.032c11.264-12.288 30.72-12.288 43.008 0 6.144 6.144 9.216 13.312 9.216 21.504S1029.12 302.08 1022.976 308.224z\" p-id=\"5958\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/down.svg
// module id = LHwD
// module chunks = 8